<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_v"></a><em class="italic">In memory of Edward Lawrence Harrison,</em></p>
<p class="ded1"><em class="italic">RAF Intelligence Burma 1943–45</em><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Dedication.vue?52228549